module.exports = __webpack_public_path__ + "img/bg-report.6a65d192.png";